import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/footer/icon-bbb-logo.png")